export const REFRESH_TOKEN_KEY = 'ionos-refresh-token';
export const ACCESS_TOKEN_KEY = 'ionos-access-token';
